Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryTicketPlaceholderView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/summary_ticket_placeholder']
  className: 'ticket-summary ticket-summary-placeholder'

  @contentHeight: 104

  render: ->
    @$el.html @template()
    @

  destroy: ->
    false
